export default "__VITE_ASSET__D9y9T9vd__"